import object from 'helpers/object'


export const initialState = {
  groups: [],
  tariffs: [],
  trainers: [],
  isFetching: true,
}


export const setGroups = (state, payload) => (
  object.setIn(state, [ 'groups' ], payload)
)

export const setTrainers = (state, payload) => (
  object.setIn(state, [ 'trainers' ], payload)
)

export const setTariffs = (state, payload) => (
  object.setIn(state, [ 'tariffs' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
